import React from 'react'

class TextArea extends React.Component {
    static getDerivedStateFromProps(props, state) {
        if (state.prevPropValue !== props.value) {
            return {
                prevPropValue: props.value,
                value: props.value || '',
            }
        }
        return {}
    }

    constructor(props) {
        super(props)
        this.state = {
            value: this.props.value,
            prevPropValue: this.props.value,
        }
        this.onChange = this.onChange.bind(this)
    }

    onChange(e) {
        this.setState({ value: e.target.value })
        this.props.onUpdate(this.props.id, { [this.props.name]: e.target.value }, this.props.payload)
    }

    render() {
        return (
            <div>
                <textarea className="control-ta" value={this.state.value} onChange={this.onChange}></textarea>
            </div>
        )
    }
}

export default TextArea
